import React from 'react';
import Loader from './notifications/Loader';

function Overlay (props) {
    return props.active ? <div id="overlay">
        <div>
            <Loader/>
        </div>
    </div> : null;
}

export default Overlay
